import React from 'react';
import Skeleton from './Skeleton';

const Text = ({ containerClassName }: { containerClassName?: string }) => {
  return (
    <div className={containerClassName}>
      <Skeleton className='h-4 w-full rounded-1' />
      <Skeleton className='h-4 w-full rounded-1' />
      <Skeleton className='h-4 w-1/3 rounded-1' />
      <Skeleton className='h-4 w-full rounded-1' />
      <Skeleton className='h-4 w-full rounded-1' />
      <Skeleton className='h-4 w-full rounded-1' />
      <Skeleton className='h-4 w-2/3 rounded-1' />
      <Skeleton className='h-4 w-full rounded-1' />
      <Skeleton className='h-4 w-1/3 rounded-1' />
      <Skeleton className='h-4 w-full rounded-1' />
      <Skeleton className='h-4 w-full rounded-1' />
      <Skeleton className='h-4 w-1/3  rounded-1' />
    </div>
  );
};

export default Text;
